export default "__VITE_ASSET__B06JGcXH__"